import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { UserAuth } from '../context/AuthContext'



const ProtectedPlugin = ({ children }) => {
  const { user } = UserAuth()
  const location = useLocation();

  if (!user) {
    // Pass along the search parameters (e.g. ?machine_id=...&product=...)
    return <Navigate to={`/signin/plugin/1${location.search || ''}`} />
  }

  return children
}

export default ProtectedPlugin